import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import productCategoryActions from 'actions/productCategories'
import userActions from 'actions/users'
import userGroupActions from 'actions/userGroups'
import supplierActions from 'actions/suppliers'
import overstockLocationActions from 'actions/overstockLocations'
import Component from 'components/Reports/TransactionAuditReport/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  users: selectors.users.selectOptions(state),
  userGroups: selectors.userGroups.selectOptions(state),
  productCategories: selectors.productCategories.selectOptions(state),
  suppliers: selectors.suppliers.selectOptions(state, { itemsOnly: false }),
  overstockLocations: selectors.overstockLocations.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(
      locationActions.getOptions({
        ...params,
        active: 'All',
        locationVendingTypes: ['NonVending', 'Vending'],
      }),
    ),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All', vending: 'All' })),
  getProductCategories: (params) =>
    dispatch(productCategoryActions.getOptions({ ...params, active: 'All', pageIndex: 0 })),
  getUserGroups: (params) => dispatch(userGroupActions.getOptions(params)),
  getSuppliers: (params) =>
    dispatch(
      supplierActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getOverstockLocations: (params) => dispatch(overstockLocationActions.getOptions(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
